export const CREATE_SEMANTIC_MODEL_CLASS_PROFILE = "https://schemas.dataspecer.com/semantic-model/operations/create-class-profile";
export function isCreateSemanticModelClassProfile(operation) {
    return operation.type === CREATE_SEMANTIC_MODEL_CLASS_PROFILE;
}
export const MODIFY_SEMANTIC_MODEL_CLASS_PROFILE = "https://schemas.dataspecer.com/semantic-model/operations/update-class-profile";
export function isModifySemanticModelClassProfile(operation) {
    return operation.type === MODIFY_SEMANTIC_MODEL_CLASS_PROFILE;
}
export const CREATE_SEMANTIC_MODEL_RELATIONSHIP_PROFILE = "https://schemas.dataspecer.com/semantic-model/operations/create-relationship-profile";
export function isCreateSemanticModelRelationshipProfile(operation) {
    return operation.type === CREATE_SEMANTIC_MODEL_RELATIONSHIP_PROFILE;
}
export const MODIFY_SEMANTIC_MODEL_RELATIONSHIP_PROFILE = "https://schemas.dataspecer.com/semantic-model/operations/update-relationship-profile";
export function isModifySemanticModelRelationshipProfile(operation) {
    return operation.type === MODIFY_SEMANTIC_MODEL_RELATIONSHIP_PROFILE;
}
export const MODIFY_SEMANTIC_MODEL_RELATIONSHIP_END_PROFILE = "https://schemas.dataspecer.com/semantic-model/operations/update-relationship-end-profile";
export function isModifySemanticModelRelationshipEndProfile(operation) {
    return operation.type === MODIFY_SEMANTIC_MODEL_RELATIONSHIP_END_PROFILE;
}
export const CREATE_CONTROLLED_VOCABULARY_ASSIGNMENT = "https://schemas.dataspecer.com/semantic-model/operations/create-controlled-vocabulary-assignment";
export function isCreateControlledVocabularyAssignment(op) {
    return op.type === CREATE_CONTROLLED_VOCABULARY_ASSIGNMENT;
}
export const REMOVE_CONTROLLED_VOCABULARY_ASSIGNMENT = "https://schemas.dataspecer.com/semantic-model/operations/delete-controlled-vocabulary-assignment";
export function isRemoveControlledVocabularyAssignment(op) {
    return op.type === REMOVE_CONTROLLED_VOCABULARY_ASSIGNMENT;
}
export const MODIFY_CONTROLLED_VOCABULARY_ASSIGNMENT = "https://schemas.dataspecer.com/semantic-model/operations/update-controlled-vocabulary-assignment";
export function isModifyControlledVocabularyAssignment(op) {
    return op.type === MODIFY_CONTROLLED_VOCABULARY_ASSIGNMENT;
}
//# sourceMappingURL=operations.js.map